import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import Element from '@/models/element';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import store from '@/store';
import { Legs } from '@/models/legs/legs';

export class LegsSupportToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const body: Element = store.getters.body;
        const legs: Legs = store.getters.shaders.selectedLegs;
        const color = 'CZA';
        const result = [];
        if (legs.shader.key === 'ShaderNSlizgacz') {
            result.push(...this.createSliderSupport(
                body,
                color,
            ));
        } else {
            result.push(...this.createLegsSupport(
                element,
                body,
                color,
            ));
        }
        return result;
    }

    private createSliderSupport(
        body: Element,
        color: string,
    ): ISimpleSapElement[] {
        const code = 'NPR';
        const dim1 = 1;
        const dim2 = 0;
        const type = this.formatType(code, dim1, dim2);
        const support = SimpleSapElement.ELEMENT(type, color);
        if (body.shape.x === 2) {
            return [support];
        } else if (body.shape.x > 2) {
            return [support, support, support];
        }
        return [];
    }

    private createLegsSupport(
        element: Element,
        body: Element,
        color: string,
    ): ISimpleSapElement[] {
        const height = element.model.split('_')[2][1];
        const code = body.shape.x === 2 ? 'NPS' : 'NPB';
        const type = this.formatType(code, height, 0);
        const support = SimpleSapElement.ELEMENT(type, color);
        const result = [];
        result.push(support);
        if (body.shape.x > 2) {
            const t = this.formatType('BPP', 1, 0);
            result.push(SimpleSapElement.ELEMENT(t, color));
        }
        return result;
    }
}
